
<template>
  <v-dialog v-model="dialog" transition="dialog-bottom-transition" scrollable>
    <template v-slot:activator="{ props }">
      <v-btn color="primary" :class="{ 'float-right': floatRight }" v-bind="props" density="compact">
        <v-icon class="mr-2">mdi-plus</v-icon>
        Novo Grupo
      </v-btn>
    </template>
    <v-card>
      <v-toolbar color="primary" :title="group.name ? `[${group.acronym}] - ${group.name} (editar grupo)` : 'Novo grupo'">
        <v-btn color="black" @click="dialog = false" density="compact"><v-icon>mdi-close</v-icon></v-btn>
      </v-toolbar>
      <v-card-text>
        <FormGroup :user="user" :group="group" @updated="createdObject" />
      </v-card-text>
      <v-card-actions class="justify-end">
        <v-btn variant="text" color="error" @click="dialog = false" density="compact">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import FormGroup from './FormGroup.vue';
export default {
  components: { FormGroup },
  props: {
    user: Object,
    floatRight: Boolean,
    group: Object,
    dialogStatus: Boolean,
  },
  data() {
    return {
      dialog: false,
    };
  },
  mounted() { },
  activated() { },
  methods: {
    createdObject(object) {
      this.$emit('updated', object)
      this.dialog = false;
    }
  },
  computed: {},
  watch: {
    dialog(newVal) {
      if (!newVal) {
        this.$emit('closed')
      }
    },
    dialogStatus(newVal) {
      if (newVal) {
        this.dialog = true
      }
    }
  }
};
</script>
